import React from 'react';
import './App.css';
import WeatherMainPageComp from './WeatherMainPage/WeatherMainPage';

function App() {
  return (
    <div>
      <WeatherMainPageComp />
    </div>
  );
}

export default App;
